import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { LABEL_ACCEPT_TERM, TEXT_ACCEPT_TERM } from "../../core/constants/termoAceite";
import { CircularProgress, Card, Checkbox, FormControlLabel } from "@material-ui/core";
import WMBack from "../../assets/images/wm_back.png";
import WMLogoOneLiner from "../../assets/icons/WMLogoOneLiner";
import clsx from "clsx";

export interface IAcceptRegisterTermPageProps {
  onSubmit: (this: void, form: boolean) => void;
  onCancel: (this: void) => void;
  loading?: boolean;
}

interface State {
  password: string;
  showPassword: boolean;
  confirmPassword: string;
  showConfirmPassword: boolean;
  currentPassword: string;
  showCurrentPassword: boolean;
}

const useStyles = makeStyles((theme) => {
  const buttonAndLoadingSpacing = theme.spacing(3, 0, 2);

  return {
    main: {
      [theme.breakpoints.down("sm")]: { padding: theme.spacing(1) },
      [theme.breakpoints.up("sm")]: { padding: theme.spacing(3) },
    },
    hiddenOverflow: {
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    divStyle: {
      width: "100%",
      height: "100vh",
      backgroundImage: `url(${WMBack})`,
      backgroundSize: "cover",
    },
    wmLogo: {
      [theme.breakpoints.down("sm")]: { width: "218px" },
      [theme.breakpoints.up("sm")]: { width: "418px" },
    },
    textField: {
      width: "100%",
      paddingBottom: 10,
      [theme.breakpoints.down("sm")]: { color: theme.palette.common.white },
      [theme.breakpoints.up("sm")]: { color: theme.palette.common.black },
    },
    textPrimary: {
      fontWeight: "bold",
      fontVariant: "h5",
      color: theme.palette.common.black,
      [theme.breakpoints.down("sm")]: { fontSize: 20 },
      [theme.breakpoints.up("sm")]: { fontSize: 24 },
    },
    textSecond: {
      textAlign: "left",
      color: theme.palette.common.black,
    },
    buttonCommom: {
      borderRadius: 0,
      color: theme.palette.common.white,
    },
    paper: {
      marginTop: theme.spacing(2),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      backgroundColor: theme.palette.common.white,
      boxShadow: "none",
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.primary.main,
    },
    info: {
      marginTop: "20px",
    },
    form: {
      width: "100%", // Fix IE 11 issue.
      marginTop: theme.spacing(1),
    },
    formArea: {
      width: "100%", // Fix IE 11 issue.
      maxHeight: "380px",
      display: "flex",
      flexDirection: "column",
      marginTop: theme.spacing(1),
      backgroundColor: theme.palette.grey[200],
    },
    formText: {
      width: "100%", // Fix IE 11 issue.
      maxHeight: "380px",
      overflowX: "auto",
      display: "flex",
      flexDirection: "column",
      marginTop: theme.spacing(1),
      padding: theme.spacing(1, 2, 1, 2),
    },
    submit_enviar: {
      margin: buttonAndLoadingSpacing,
      width: "100px",
      [theme.breakpoints.down("sm")]: { marginLeft: "4%" },
      [theme.breakpoints.up("sm")]: { marginLeft: "1%" },
    },
    submit_cancelar: {
      margin: buttonAndLoadingSpacing,
      width: "100px",
    },
    loading: {
      display: "flex",
      justifyContent: "center",
      padding: buttonAndLoadingSpacing,
    },
    section: {
      "& svg": {
        "& .fil0": {
          fill: theme.palette.common.white,
        },
      },
      "textAlign": "center",
    },
  };
});

const AcceptRegisterTermPage = (props: IAcceptRegisterTermPageProps) => {
  const [formValues, setFormValues] = useState<boolean>(false);
  const [buttonEnable, setButtonEnable] = useState(false);
  const [textEnable, setTextEnable] = useState(true);

  const [state, setState] = React.useState({
    checkedA: false,
  });

  const handleCheckChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setButtonEnable(event.target.checked);
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const { onSubmit, onCancel, loading } = props;

  const doConfirmar = () => {
    onSubmit(formValues);
  };

  const doCancel = () => {
    onCancel();
  };

  const classes = useStyles();
  return (
    <section className={clsx(classes.hiddenOverflow, classes.divStyle)}>
      <section className={classes.section}>
        <WMLogoOneLiner className={classes.wmLogo} />
        <Container component="main" maxWidth="xl">
          <CssBaseline />
          <Card className={clsx(classes.paper, classes.main)}>
            <Typography component="h1" className={classes.textPrimary}>
              {LABEL_ACCEPT_TERM}
            </Typography>
            <form className={classes.form} noValidate>
              <form className={classes.formArea} noValidate>
                <form className={classes.formText} noValidate>
                  {TEXT_ACCEPT_TERM.split("\n").map((i, key) => {
                    return (
                      <Typography
                        key={key}
                        paragraph
                        variant="body1"
                        className={classes.textSecond}
                      >
                        {i}
                      </Typography>
                    );
                  })}
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={state.checkedA}
                        onChange={handleCheckChange}
                        name="checkedA"
                        color="primary"
                      />
                    }
                    label="Eu li e concordo com os termos e condições"
                  />
                </form>
              </form>
              <Button
                variant="contained"
                color="primary"
                className={clsx(classes.submit_cancelar, classes.buttonCommom)}
                onClick={doCancel}
              >
                Cancelar
              </Button>
              {!loading ? (
                <Button
                  variant="contained"
                  color="primary"
                  className={clsx(classes.submit_enviar, classes.buttonCommom)}
                  onClick={doConfirmar}
                  disabled={!buttonEnable}
                >
                  Confirmar
                </Button>
              ) : (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              )}
            </form>
          </Card>
        </Container>
      </section>
    </section>
  );
};

export default AcceptRegisterTermPage;
